import axios from "axios"
import { REACT_APP_YT_API_KEY } from "./api"
const request = axios.create({
    baseURL: 'https://youtube.googleapis.com/youtube/v3/',
    params: {
        key: REACT_APP_YT_API_KEY
    }
})

export default request